export const active_currencies = [
    'EUR',
    'USD',
    'GBP',
    'RUB',
]
